import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from 'reactstrap';

export interface FooterProps {}

const Footer: React.FC<FooterProps> = () => (
    <footer className="py-4 bg-light mt-auto">
        <Container className="px-4" fluid>
            <div className="d-flex align-items-center justify-content-center small">
                <div className="text-muted">Copyright &copy; Kyuto Techno Co.,ltd. All rights reserved.</div>
            </div>
        </Container>
    </footer>
);

export default Footer;
